/**
 * OPLYX — Feature Catalog (single source of truth)
 *
 * Mapa autoritativo: key (back-end feature flag) → labels para Admin e Landing.
 * Ordem dos grupos = ordem em que aparecem na landing pública.
 *
 * Quando você adiciona uma feature nova:
 *   1. Inclua aqui (com labels)
 *   2. Adicione default value em backend/server.py (_BASIC_FEATURES / _FULL_FEATURES)
 *   3. Adicione nos PRESETs de AdminPlans.jsx
 *   4. Toggle no admin → reflete na landing automaticamente
 */
export const FEATURE_CATALOG = [
  {
    group: "Operação diária",
    items: [
      { key: "pos",        label: "PDV + Caixa + Comandas",                       landing: "PDV + Caixa + Comandas" },
      { key: "comandas",   label: "Comandas com modifiers/observações",           landing: "Comandas" },
      { key: "kds",        label: "KDS: monitor de cozinha",                     landing: "KDS: monitor de cozinha" },
      { key: "live_ops",   label: "Live Ops: situação da operação em tempo real", landing: "Live Ops · status do salão e cozinha em tempo real" },
      { key: "gorjetas",   label: "Gorjetas com repasse automático",              landing: "Gorjetas com repasse automático" },
      { key: "tasks",      label: "Checklists / Rotinas",                         landing: "Checklists operacionais" },
    ],
  },
  {
    group: "Fiscal",
    items: [
      { key: "nfce",       label: "Emissão NFC-e",                  landing: "Emissão NFC-e" },
      { key: "nfe",        label: "Emissão NF-e",                   landing: "Emissão NF-e" },
      { key: "purchases",  label: "Importação NF-e de compras",     landing: "Importação NF-e de compras" },
    ],
  },
  {
    group: "Financeiro & Contábil",
    items: [
      { key: "financeiro",   label: "Controle financeiro completo", landing: "Controle financeiro completo" },
      { key: "dre",          label: "DRE contábil real por período/filial", landing: "DRE contábil real por período e filial" },
      { key: "metas",        label: "Metas auto-geradas pelo DRE (exclusivo Full)", landing: "Metas auto-geradas pelo DRE" },
      { key: "sales_report", label: "Relatório detalhado de vendas (com filtros)", landing: "Relatório de vendas com filtros e exportação" },
      { key: "reports",      label: "Relatórios & Exports",          landing: "Conciliação bancária OFX" },
      { key: "dashboard",    label: "Dashboard de KPIs",             landing: "Dashboard de KPIs" },
    ],
  },
  {
    group: "Estoque & Fichas",
    items: [
      { key: "estoque",       label: "Estoque com lot tracking",       landing: "Estoque com lot tracking" },
      { key: "cmv",           label: "CMV por produto",                landing: "CMV por produto" },
      { key: "recipes",       label: "Fichas técnicas versionadas + auto-recost", landing: "Fichas técnicas versionadas + auto-recost" },
      { key: "replenishment", label: "Lista de reposição inteligente", landing: "Lista de reposição inteligente" },
      { key: "consumption",   label: "Consumo automático para insumos indiretos (único)", landing: "Consumo automático · papel, álcool, detergente" },
    ],
  },
  {
    group: "Clientes & Engajamento",
    items: [
      { key: "crm",        label: "CRM com histórico por cliente",      landing: "CRM com histórico por cliente + cashback" },
      { key: "cashback",   label: "Programa de cashback",               landing: "Programa de pontos + ranking da equipe" },
      { key: "marketing",  label: "Marketing / Reativação",             landing: "Reativação automática de inativos" },
      { key: "waitlist",   label: "Fila de espera virtual (avisos por mensagem)",  landing: "Fila de espera virtual com avisos no WhatsApp" },
    ],
  },
  {
    group: "Gestão de equipe",
    items: [
      { key: "attendance", label: "Controle de ponto + gestão de equipe", landing: "Controle de ponto + gestão de equipe" },
    ],
  },
  {
    group: "Plataforma / Avançado",
    items: [
      { key: "multi_branch",  label: "Multi-filial (cobrar filial extra)", landing: "Multi-filial" },
      { key: "webhook",       label: "Webhooks",                           landing: "APIs + Webhooks" },
      { key: "roastery",      label: "Torrefação (add-on Roastery)",       landing: "Módulo Roastery (opcional)" },
    ],
  },
  {
    group: "Inteligência",
    items: [
      { key: "intelligence", label: "OPLYX Intelligence: copiloto de gestão com IA", landing: "OPLYX Intelligence · copiloto de gestão com IA" },
    ],
  },
];

/**
 * Retorna apenas as bullets ATIVAS no plano, na ordem do catálogo,
 * formatadas para a landing (campo `landing`).
 */
export function planLandingBullets(planFeatures = {}) {
  const out = [];
  for (const g of FEATURE_CATALOG) {
    for (const f of g.items) {
      if (planFeatures[f.key]) out.push(f.landing);
    }
  }
  return out;
}
